module.exports = __webpack_public_path__ + "img/topicChildProducts.004d8acb.svg";